
































import {Vue, Component, Mixins, Watch} from 'vue-property-decorator';
import PostListing from '@/components/Views/Blog/PostListing.vue';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {POST_STATUS} from '@/common';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
const MugenScroll = require('vue-mugen-scroll');
@Component({
    components: {
        PostListing,
        MugenScroll
    },
})
export default class BlogHome extends Mixins(UserRoleMixin, GlobalAlertMixin) {
    public page = 0;
    public loading = false;
    public perPage = 10;
    public totalPosts = -1;
    public posts = [];
    public selectedStatus = 0;
    async onInfiniteScroll(){
        console.log('doing inf scroll');
        const {Post} = this.$FeathersVuex;
        if(this.postsRemain){
            const currentScrollPosition = document.documentElement.scrollTop;
            this.loading = true;
            const results = await Post.find({
                query:{
                    $sort:{
                      updatedAt:1,
                    },
                    $limit:this.perPage,
                    $skip: this.page * this.perPage,
                    status:this.postType,
                }
            });
            this.page++;
            this.posts = [...this.posts, ...results.data];
            this.$nextTick(()=>{
                document.documentElement.scrollTo(0, currentScrollPosition)
            });
            setTimeout(()=>{
                this.loading = false;
            }, 1200)

        }
    }
    mounted(){
        this.init();
    }
    async init(){
        if(this.totalPosts === -1){
            const {Post} = this.$FeathersVuex;
            const count = await Post.find({query:{$limit:0, status:this.postType}});
            this.totalPosts = count.total;
        }
        this.onInfiniteScroll();
    }
    public reset(){
        this.page = 0;
        this.totalPosts = -1;
        this.posts = [];
        this.init();
    }
    get postsRemain() {
        return (this.page * this.perPage) < this.totalPosts;
    }
    @Watch('postType')
    onPostTypeChanged(value: string, oldValue: string){
        this.reset();
    }
    get postType(){
        if(!this.userIsAdmin) return POST_STATUS.PUBLISHED;
        return [POST_STATUS.PUBLISHED,POST_STATUS.DRAFT,POST_STATUS.TRASHED][this.selectedStatus];
    }

    public onTrash(post){
        this.changeStatus(post, POST_STATUS.TRASHED, 'trashed')
    }
    public onPublish(post){
        this.changeStatus(post, POST_STATUS.PUBLISHED, 'published')
    }
    public onDraft(post){
        this.changeStatus(post, POST_STATUS.DRAFT, 'drafted')
    }
    public onDelete(post){

    }
    public async changeStatus(post, statusKey, statusLabel){
        post.status = statusKey;
        try {
            await post.save();
            this.posts = this.posts.filter(x=>x._id != post._id);
            this.showAlert(`Successfully ${statusLabel}!`, 'success');
        } catch(e){
            console.log(e);
            this.showAlert(`Error encounter, your post was not ${statusLabel}`, 'error');
        }
    }

}
